import { ValidationMessage, ValidationMessageType } from '@sdbn/appclient';
import { MatLegacyDialog as MatDialog }from '@angular/material/legacy-dialog';
import { FlowStepHandleResult, HandleResultType, StepControl, AbstractStepController, StepControlType, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { ConfirmDialogComponent, ConfirmDialogData } from 'src/app/shared/confirm-dialog/confirm.dialog.component';
import { HttpService } from '@sdbn/appclient';
import { ResponseStatus } from '@sdbn/appclient';
import { environment } from 'src/environments/environment';
import { LogContainer } from 'src/tmc-common/model/log-container.model';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { TerminalVisitorRegistration } from '../widgets/terminal/visitor-registration.model';

export class VisitorLeaveWithBarcodeController extends AbstractStepController {

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {

    }

    private validateRegistrationCodeAndGetVisitData() {

        const httpService = WizardServiceLocator.injector.get(HttpService);

        this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, true);
        return httpService.postWithContext(environment.registrationVisitorWithBarcodeEndpoint, {value: this.dashboardContext.getContextValue('barcodeScanned')})
          .toPromise().then((response: TerminalVisitorRegistration) => {
            this.dashboardContext.setContextValue(TerminalContextConstants.isLoading, false);
            this.dashboardContext.setContextValue(TerminalContextConstants.responseMessages, response.responseMessages);
            if (response.status !== ResponseStatus.FAILED) {

                const registration = new TerminalVisitorRegistration(response);

                this.dashboardContext.setContextValue(TerminalContextConstants.numberPlate, registration.numberPlate);
                this.dashboardContext.setContextValue(TerminalContextConstants.lastname, registration.name);
                this.dashboardContext.setContextValue(TerminalContextConstants.firstname, registration.firstname);
                this.dashboardContext.setContextValue(TerminalContextConstants.company, registration.company);
                this.dashboardContext.setContextValue(TerminalContextConstants.gcCaseId, registration.gcCaseId);
                this.dashboardContext.setContextValue(TerminalContextConstants.registrationId, registration.registrationId);
                this.dashboardContext.setContextValue(TerminalContextConstants.reasonForVisit, registration.reason);
                this.dashboardContext.setContextValue(TerminalContextConstants.visitedPerson, registration.visitedPerson);
                this.dashboardContext.setContextValue('needsAreaAccess', registration.needsAreaAccess);

                if (registration.inYard) {
                  const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
                  logContainer.addLog('Valid code detected. Visitor in yard. Start leave process');
                  this.wizardComponent.next();
                }
            } else {
              const validationMessages = new Array<ValidationMessage>();
              for (const responseMessage of response.responseMessages) {
                validationMessages.push(ValidationMessage.createWithData(ValidationMessageType.ERROR, responseMessage.dictionaryKey));
              }
              this.dashboardContext.setContextValue('validationMessages', validationMessages);
              this.dashboardContext.setContextValue('responseMessages', response.responseMessages);
            }
        }, error => {
            // TODO specify what happens for bad codes
        });
    }

    public handleFlow(): FlowStepHandleResult {
        this.wizardComponent.startInactivityMonitoring();
        const logContainer: LogContainer = this.dashboardContext.context.get(TerminalContextConstants.logContainer);
        logContainer.addLog('registration code validation started');

        this.validateRegistrationCodeAndGetVisitData();

        const result = new FlowStepHandleResult();
        result.type = HandleResultType.DASHBOARD;
        return result;
    }

    private cancel() {
        const matDialog = WizardServiceLocator.injector.get(MatDialog);
        const dialogData: ConfirmDialogData = {
            titleKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.title',
            messageKey: 'tmc-yard.widgets.registration-terminal.cancel-dialog.message',
            confirm: () => {
                this.wizardComponent.stopInactivityMonitoring();
                this.wizardComponent.restartWizard();
            }
        };
        matDialog.open(ConfirmDialogComponent, {
            data: dialogData
        });
    }

    getControls(): StepControl[] {
      const controls = new Array<StepControl>();

      const previousControl = new StepControl();
      previousControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.previous';
      previousControl.type = StepControlType.BUTTON_STROKED;
      previousControl.iconBeforeCss = 'fa-thin fa-angle-left';
      previousControl.controlAction = () => {
          this.wizardComponent.stopInactivityMonitoring();
          this.wizardComponent.previous();
      };
      controls.push(previousControl);

      let spacer = new StepControl();
      spacer.type = StepControlType.SPACER_GROW;
      controls.push(spacer);

      const cancelControl = new StepControl();
      cancelControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.button.cancel';
      cancelControl.type = StepControlType.BUTTON_STROKED;
      cancelControl.iconBeforeCss = 'fa-thin fa-xmark';
      cancelControl.controlAction = this.cancel.bind(this);
      controls.push(cancelControl);

      spacer = new StepControl();
      spacer.type = StepControlType.SPACER;
      controls.push(spacer);

      const newRegistrationControl = new StepControl();
      newRegistrationControl.labelDictionaryKey = 'tmc-yard.widgets.registration-terminal.transport-registration-with-code.button.alternative';
      newRegistrationControl.type = StepControlType.BUTTON_STROKED;
      newRegistrationControl.iconAfterCss = 'fa-thin fa-angle-right';
      newRegistrationControl.controlAction = () => {
          this.wizardComponent.stopInactivityMonitoring();
          this.wizardComponent.restartWizard();
      };
      controls.push(newRegistrationControl);

      return controls;
  }
}
